import "./DonationInfo.scss";
import { MainContext } from "../../../components/WebContext";
import { useContext } from "react";

const DonationInfo = ({ data }) => {
  const { setPaymentModal } = useContext(MainContext);
  return (
    <section className="donation_info p_t p_b">
      <div className="content_wrap">
        <h1>{data?.heading}</h1>
        <p className="special">{data?.description}</p>
        <h4 className="text-center">{data?.join_title}</h4>

        <h4 className="line text-center" onClick={() => setPaymentModal(true)}>
          {data?.link_title}
        </h4>
      </div>
    </section>
  );
};
export default DonationInfo;
